import BaseFormMixin from './BaseFormMixin';

export default {
    mixins: [
        BaseFormMixin,
    ],
    inject: {
        $validator: '$validator'
    },
    props: {
    },
    data() {
        return {
            form: {},
        }
    },
    computed: {
    },
    methods: {
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler: function(value, oldValue){
                this.form = value;
            }
        },
        form: {
            deep: true,
            handler: function(value, oldValue){
                this.$emit('input', value);
            }
        },
    }
}